module.exports = __webpack_public_path__ + "img/flower.be5030ca.webp";